module.exports = __webpack_public_path__ + "img/quest_validation_error.96e61ceb.svg";